import { useState } from "react";
import { useLocation } from "wouter";
import { gradient, textGradient, COLOR } from "../common/css/colors";

import { post } from "../common/net/requester";

import { A, Button, EmailEntry } from "../components";
import { UsernameEntry } from "../components/molecules/UsernameEntry";

import "../styles/signup.css";

const userTypes = {
    WAGIE: 1,
    FREEMAN: 2,
};

const Signup = () => {
    const [, setLocation] = useLocation();

    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [emailIsValid, setEmailIsValid] = useState(false);
    const [userType, setUserType] = useState(0);

    const signupInit = () => {
        post("/auth/signup", { username, email })
            .then((res) => {
                if (!res.ok) {
                    console.log(res.status, res.message);
                    return;
                }

                const queryParams = new URLSearchParams({ email });

                setLocation("/verify?" + queryParams);
            })
            .catch((err) => {
                console.error("fail to signup:", err);
            });
    };

    return (
        <div className="routeParent">
            <div className="routeInner">
                <a
                    className="signupQuestieHeader"
                    href="/"
                    style={{ textDecoration: "none" }}
                >
                    <h1
                        style={{
                            ...textGradient(COLOR.teal3, COLOR.lime3),
                            userSelect: "none",
                        }}
                    >
                        questie
                    </h1>
                </a>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "1em",
                        border: "1px solid",
                        borderRadius: "4px",
                        padding: "2em",
                    }}
                >
                    <h3>Welcome, user</h3>

                    <h5>What are you?</h5>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1em",
                        }}
                    >
                        <div
                            style={gradient(COLOR.red1, COLOR.orange, -45)}
                            className={`userTypeCard ${
                                userType === userTypes.WAGIE && "active"
                            }`}
                            onClick={() => setUserType(userTypes.WAGIE)}
                        >
                            <h2>Avid Quester</h2>
                            <h5>TODO: svg</h5>
                        </div>
                        <div
                            style={gradient(COLOR.teal5, COLOR.blue1, 45)}
                            className={`userTypeCard ${
                                userType === userTypes.FREEMAN && "active"
                            }`}
                            onClick={() => setUserType(userTypes.FREEMAN)}
                        >
                            <h2>Noob</h2>
                            <h5>TODO: svg</h5>
                        </div>
                    </div>

                    <UsernameEntry
                        username={username}
                        setUsername={setUsername}
                    />

                    <EmailEntry
                        email={email}
                        setEmail={setEmail}
                        setEmailIsValid={setEmailIsValid}
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "3em",
                        }}
                    >
                        <div>
                            Have an account?{" "}
                            <A href={"/login"} text={"Log in"} />
                        </div>

                        <Button
                            text="Sign up"
                            disabled={!emailIsValid}
                            onClick={signupInit}
                            background={
                                gradient(COLOR.green, COLOR.pink1, 45)
                                    .background
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Signup;
